import { createContext, FunctionComponent, useContext, useEffect, useState } from 'react';
import { useAuthentication } from 'src/features/authentication/context';
import { SEPARATOR, SITE } from '../config/config';
import { getFilterResponse } from '../helper';
import { AssetService } from 'src/services/assets/asset.service';

const sitesContext = createContext<any>({});

interface ISitesContextProviderProps {
  isAsset: boolean;
  template: any;
  children: JSX.Element;
  methods: any;
  onLoad: () => void;
  filtersLoaded: boolean;
}

// TODO: try and cache this
export const SitesContextProvider: FunctionComponent<ISitesContextProviderProps> = ({
  isAsset,
  children,
  template,
  methods,
  onLoad,
  filtersLoaded,
}) => {
  const [isLoading, setIsLoading] = useState(isAsset ? true : false);
  const [sites, setSites] = useState<any>([]);

  const [initialFilters, setInitialFilters] = useState<any>(null);
  const {
    customerId: { value: customerId },
    sites: sitesData,
  } = useAuthentication();

  useEffect(() => {
    if (isAsset && !filtersLoaded) {
      (async () => {
        try {
          setIsLoading(true);

          setSites(
            sitesData.value.map(
              (site: any) => `${SITE}${SEPARATOR}${site.siteName}${SEPARATOR}${site.id}`
            )
          );
          onLoad();

          setIsLoading(false);
        } catch (err) {
          setIsLoading(false);
        }
      })();
    }
  }, [customerId, onLoad, filtersLoaded, setInitialFilters, isAsset, template, methods, sitesData]);

  useEffect(() => {
    (async () => {
      if (template.state && template.state.filters && !isLoading && sitesData.value.length) {
        const assets = await AssetService.getAllGlobal(customerId!);
        const parsedFilters = getFilterResponse(template.state.filters, sitesData.value, assets);

        setInitialFilters(parsedFilters);
        methods.setValue('filters', parsedFilters);
      }
    })();
  }, [template, isLoading, methods, sites, sitesData.value, customerId]);
  return (
    <sitesContext.Provider value={{ isLoading, sites, initialFilters }}>
      {children}
    </sitesContext.Provider>
  );
};

export const useFilterSites = () => useContext(sitesContext);
